/*
 * @Author: wangyunlin wangyunlin@morewis.com
 * @Date: 2022-10-17 22:25:57
 * @LastEditors: wangyunlin wangyunlin@morewis.com
 * @LastEditTime: 2023-03-27 11:54:12
 * @FilePath: \douyin\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
Vue.config.productionTip = false
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
import { Icon } from 'vant';

Vue.use(Icon);

import { Overlay } from 'vant';

Vue.use(Overlay);
import { Popup } from 'vant';

Vue.use(Popup);
import moment from "moment"
Vue.prototype.$moment = moment;


import { Toast } from 'vant';
Vue.use(Toast);

import VueWechatTitle from 'vue-wechat-title' //可以动态修改浏览器标题的插件
Vue.use(VueWechatTitle);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
